import React from "react";

const BoxWrapper = ({ children, className }) => {
  return (
    <section
      className={`md:bg-base-light-white md:dark:bg-base-input-gray bg-base-white dark:bg-base-light-dark p-[3px] rounded-[5px] overflow-hidden flex flex-col md:gap-[0px] gap-[2px] ${className}`}
    >
      {children}
    </section>
  );
};

export default BoxWrapper;
